export default __webpack_public_path__ + "static/media/pixa-logo.518156bc.gif";